import AgencySettings from "../../../../components/agency_settings/AgencySettings.vue"

export default [
    {
        path: '/agency-settings',
        name: 'Agency Settings',
        meta: { layout: 'mystagit' },
        component: AgencySettings,
    },
]